<div class="modal-header">
  <h5 class="modal-title">Select Date to Send</h5>
  <button (click)="close()" type="button" class="close">
    <i class="fas fa-times"></i>
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="form" class="row">
    <div class="col-sm-6">
      <mat-form-field class="mat-block">
        <input
          type="text"
          placeholder="After x Hours"
          matInput
          [formControl]="form.get('hours')"
          [matAutocomplete]="auto"
          required
        />
        <mat-autocomplete #auto="matAutocomplete">
          <mat-option *ngFor="let item of hourOptions" [value]="item.hour">
            {{ item.label }}
          </mat-option>
        </mat-autocomplete>
        <mat-error *ngIf="form.get('hours').touched && form.get('hours').hasError('required')">
          Value is <strong>required</strong>
        </mat-error>
        <mat-error *ngIf="form.get('hours').touched && form.get('hours').hasError('min')">
          Min value is <strong>1 hour</strong>
        </mat-error>
        <mat-error *ngIf="form.get('hours').touched && form.get('hours').hasError('max')">
          Max value is <strong>72 hours</strong>
        </mat-error>
      </mat-form-field>
    </div>
    <div *ngIf="date" class="col-sm-12">Scheduled to be sent on: {{ date | epoch: 'YYYY-MM-DD HH:mm A' }}</div>
  </form>
</div>
<div class="modal-footer">
  <button (click)="close()" type="button" class="btn btn-outline btn-default-outline text-uppercase">
    <i class="fal fa-times"></i>
    Cancel
  </button>
  <button (click)="onSave(form)" class="btn btn-success text-uppercase create-btn" type="button">
    <i class="fal fa-clock"></i> Schedule
  </button>
</div>
